import { Box, Slider, TextField, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { Pie, PieChart, ResponsiveContainer } from "recharts";
import Breadcrumbs from "../../../../../component/Breadcrumbs";
import CommonButton from "../../../../../component/Button";
import DropDownSelect from "../../../../../component/Select";
import { CommonGrid2 } from "../../../../../modules/common-components/StyledComponents";
import { HandleSkeletion } from "../../../../../utils/constants";

export default function WeightEdit({
  handleSubmit,
  handleNumberChange,
  handleSetToDefault,
  handleCancel,
  handleSliderChange,
  dropDownData,
  breadCrumbData,
  weightList,
  renderCustomLabel,
}) {
  return (
    <Fragment>
      <Breadcrumbs breadCrumbData={breadCrumbData} />
      {(weightList.loading
        ? [1]
        : weightList.data && weightList.data.length != 0 && weightList.data
      ).map((innerItem, _) => (
        <Fragment>
          <CommonGrid2
            container
            spacing={2}
            alignItems="center"
            marginTop={2.5}
            justifyContent={"space-between"}
          >
            {weightList.loading ? (
              <HandleSkeletion width="150px" height="50px" />
            ) : (
              <CommonGrid2 item>
                <Typography variant="h3" textTransform={"capitalize"}>
                  {innerItem.name}
                </Typography>
              </CommonGrid2>
            )}

            <CommonGrid2
              item
              gap="1rem"
              justifyContent="end"
              display="flex"
              flexWrap={"wrap"}
            >
              <CommonButton
                variant="outlined"
                color="#344054"
                border="#D0D5DD"
                fontWeight="600"
                value={"Cancel"}
                padding="8px 15px"
                disabled={weightList.disabled}
                onClick={handleCancel}
              />
              <CommonButton
                variant="outlined"
                color="#344054"
                border="#D0D5DD"
                fontWeight="600"
                value={"Set to default"}
                padding="8px 15px"
                disabled={weightList.disabled}
                loading={weightList.save_as_loading}
                onClick={handleSetToDefault}
              />
              <CommonButton
                fontWeight="600"
                value={"Save"}
                loading={weightList.save_loading}
                onClick={handleSubmit}
                disabled={weightList.disabled}
                padding="8px 15px"
              />
            </CommonGrid2>
          </CommonGrid2>

          <CommonGrid2
            border={"1px solid #EAECF0"}
            padding={"1rem"}
            borderRadius={"10px"}
            container
            spacing={2}
            marginTop={"2rem"}
          >
            <CommonGrid2 item size={{ xs: 12, lg: 6 }}>
              <CommonGrid2
                height={"100%"}
                display={"flex"}
                justifyContent={"space-between"}
                flexDirection={"column"}
              >
                {weightList.loading ? (
                  <HandleSkeletion
                    width="150px"
                    height="50px"
                    // transform="scale(1)"
                  />
                ) : (
                  <Typography variant="h5">Weight Distribution</Typography>
                )}
                <CommonGrid2
                  marginTop={"2rem"}
                  container
                  flexDirection={"column"}
                  // gap={"2rem"}
                  spacing={3}
                >
                  {(weightList.loading
                    ? [1]
                    : innerItem && innerItem.fields && innerItem.fields
                  ).map((item, index) => (
                    <Fragment>
                      {weightList.loading ? (
                        <HandleSkeletion
                          width="auto"
                          height="50px"
                          transform="scale(1)"
                        />
                      ) : (
                        <CommonGrid2>
                          <Typography variant="p">{item.name}</Typography>
                          <CommonGrid2
                            display={"flex"}
                            gap={"1rem"}
                            alignItems={"center"}
                          >
                            <Slider
                              defaultValue={item.value}
                              value={item.value}
                              valueLabelDisplay="auto"
                              onChange={(_, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              sx={{
                                height: "7px",

                                "& .MuiSlider-rail": {
                                  backgroundColor: "#d1d2d4",
                                },
                                "& .MuiSlider-thumb": {
                                  width: 22,
                                  height: 22,
                                  backgroundColor: "#fff",
                                  border: "2px solid #7F56D9",
                                },
                                "& .MuiSlider-valueLabel": {
                                  backgroundColor: "#6941C6",
                                  fontSize: "13px",
                                  color: "white",
                                },
                              }}
                            />
                            <TextField
                              value={item.value}
                              style={{
                                width: "50px",
                                position: "relative",
                                top: "-13px",
                              }}
                              InputProps={{ endAdornment: "%" }}
                              variant="standard"
                              onChange={(e) => {
                                const value = e.target.value;
                                const n = value === "" ? 0 : Number(value);
                                if (/^[0-9]*$/.test(n)) {
                                  handleNumberChange(n, index);
                                }
                                // handleNumberChange(e, index);
                              }}
                            />
                          </CommonGrid2>
                        </CommonGrid2>
                      )}
                    </Fragment>
                  ))}
                </CommonGrid2>
              </CommonGrid2>
            </CommonGrid2>
            <CommonGrid2 item size={{ xs: 12, lg: 6 }}>
              <CommonGrid2
                height={"100%"}
                display={"flex"}
                justifyContent={"space-between"}
                flexDirection={"column"}
              >
                {weightList.loading ? (
                  <HandleSkeletion
                    width="auto"
                    height="50px"
                    // transform="scale(1)"
                  />
                ) : (
                  <CommonGrid2 display={"flex"} justifyContent={"end"}>
                    <DropDownSelect
                      customStyle={{
                        width: "200px",
                      }}
                      marginTop="0px"
                      title={"Select Value"}
                      removeAnimation={true}
                      data={dropDownData}
                      value={"Custom"}
                    />
                  </CommonGrid2>
                )}
                <Box
                  width="100%"
                  display="flex"
                  justifyContent="center"
                  marginTop={"1rem"}
                >
                  {weightList.loading ? (
                    <HandleSkeletion
                      width="100%"
                      height="100px"
                      transform="scale(1)"
                    />
                  ) : (
                    <ResponsiveContainer width="100%" height={300}>
                      <PieChart>
                        <Pie
                          data={innerItem.fields}
                          dataKey="value"
                          cx="50%"
                          cy="50%"
                          innerRadius="45%"
                          outerRadius="65%"
                          label={renderCustomLabel}
                          paddingAngle={2}
                          cornerRadius={4}
                        />
                        <text
                          x="50%"
                          y="50%"
                          textAnchor="middle"
                          dominantBaseline="middle"
                          style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            fill: "#333",
                          }}
                        >
                          {innerItem.overall_score}%
                        </text>
                      </PieChart>
                    </ResponsiveContainer>
                  )}
                </Box>
              </CommonGrid2>
            </CommonGrid2>
          </CommonGrid2>
        </Fragment>
      ))}
    </Fragment>
  );
}
